import dynamic from 'next/dynamic'

import { useNewsletterSignupBanner } from './hooks/useNewsletterSignupBanner'
import { FireSignupWidgetProps } from './types'

const NewsletterBannerDynamic = dynamic(
  () =>
    import('./components/NewsletterBanner').then(
      ({ NewsletterBanner }) => NewsletterBanner
    ),
  {
    ssr: false,
  }
)

export function FireNewsletterSignup(props: FireSignupWidgetProps) {
  const { isBannerShown, isSubscribed, queryTrigger } =
    useNewsletterSignupBanner(props)

  if (!queryTrigger && (isSubscribed || !isBannerShown)) return null

  return <NewsletterBannerDynamic {...props} />
}

export default FireNewsletterSignup
